import Vue from "vue";
import App from "./App.vue";
import Vuex from "vuex";
import "regenerator-runtime/runtime";
import { createProvider } from "./vue-apollo";
import i18n from "./i18n";

Vue.use(Vuex);

const store = new Vuex.Store({
  state: {
    filterTags: [],
    filterActors: [],
    filterMaterials: [],
    filterPlaces: [],
  },
  mutations: {
    filterAddTag(state, payload) {
      state.filterTags.push(payload);
    },
    filterRemoveTag(state, payload) {
      state.filterTags = state.filterTags.filter((item) => {
        return item._id != payload._id;
      });
    },
    filterResetTags(state) {
      state.filterTags = [];
    },
    filterAddActor(state, payload) {
      state.filterActors.push(payload);
    },
    filterRemoveActor(state, payload) {
      state.filterActors = state.filterActors.filter((item) => {
        return item._id != payload._id;
      });
    },
    filterResetActors(state) {
      state.filterActors = [];
    },
    filterAddMaterial(state, payload) {
      state.filterMaterials.push(payload);
    },
    filterRemoveMaterial(state, payload) {
      state.filterMaterials = state.filterMaterials.filter((item) => {
        return item._id != payload._id;
      });
    },
    filterResetMaterials(state) {
      state.filterMaterials = [];
    },
    filterAddPlace(state, payload) {
      state.filterPlaces.push(payload);
    },
    filterRemovePlace(state, payload) {
      state.filterPlaces = state.filterPlaces.filter((item) => {
        return item._id != payload._id;
      });
    },
    filterResetPlaces(state) {
      state.filterPlaces = [];
    },
  },
  actions: {
    resetFilters({ commit }) {
      commit("filterResetTags");
      commit("filterResetActors");
      commit("filterResetMaterials");
      commit("filterResetPlaces");
    },
  },
});

Vue.config.productionTip = false;

new Vue({
  el: "#app",
  apolloProvider: createProvider(),
  render: (h) => h(App),
  i18n,
  store: store,
});
